import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "chevron"]

  toggle(event) {
    const button = event.currentTarget
    const wrapper = button.parentElement
    const body = wrapper.querySelector('[data-weather-accordion-target="body"]')
    const chevron = button.querySelector('[data-weather-accordion-target="chevron"]')
    const isOpen = !body.classList.contains("hidden")

    if (isOpen) {
      body.classList.add("hidden")
      if (chevron) chevron.classList.remove("rotate-180")
    } else {
      body.classList.remove("hidden")
      if (chevron) chevron.classList.add("rotate-180")
    }
  }
}
